import * as Sentry from '@sentry/vue'
import { App } from 'vue'
import { Router } from 'vue-router'

export function configureSentry(app: App<Element>, router: Router) {
  console.log('configureSentry ::::', location.hostname)
  if (location.hostname === 'next-auto.nominasaps.com') {
    Sentry.init({
      app,
      dsn: 'https://350c84a35efd69f1f1f8d4c2e8c484d1@o4505837159251968.ingest.us.sentry.io/4509282613002240',
      integrations: [
        Sentry.browserTracingIntegration({
          router,
        }),
        Sentry.replayIntegration({
          networkDetailAllowUrls: [
            'https://api-next-auto.nominasaps.com',
            'api-next-auto.nominasaps.com',
          ],
          networkCaptureBodies: true,
          networkRequestHeaders: ['authorization'],
          maskAllInputs: false,
          maskAllText: false,
        }),
      ],
      beforeSend(event, hint) {
        // Safely extract status code from axios errors only
        let statusCode: number | undefined

        try {
          const originalException = hint.originalException
          // Only access response.status if it's actually an axios error
          if (
            originalException &&
            typeof originalException === 'object' &&
            'response' in originalException
          ) {
            const axiosError = originalException as any
            if (
              axiosError.response &&
              typeof axiosError.response === 'object' &&
              'status' in axiosError.response
            ) {
              statusCode = axiosError.response.status
            }
          }
        } catch (e) {
          // If any error occurs while accessing properties, just skip
          statusCode = undefined
        }

        console.log(
          'Sentry beforeSend event:',
          event,
          'Status Code:',
          statusCode
        )

        // If the status code is 400-499, don't send the event to Sentry
        if (statusCode !== undefined && statusCode < 500 && statusCode >= 400) {
          return null // Returning null will drop the event
        }

        // For all other errors, send them to Sentry
        return event
      },
      release: 'autogestion@2.0.0',
      // Performance Monitoring
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ['https://api-next-auto.nominasaps.com'],
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    })
  }
}
